import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import { Icon } from "@iconify/react";
import { Avatar } from "@mui/material";
import { NavLink } from "react-router-dom";

const PreleadCard = ({
  columnKey,
  task,
  index,
  onEdit,
  onDelete,
  onSkip,
  showPhoneModal,
  showWhatsAppModal,
  onReschedule, // <-- Add this prop
}) => {
  const { contact_id = {}, complete = {} } = task;

  return (
    <Draggable draggableId={task?.id} index={index}>
      {(provided, snapshot) => (
        <div
          className="kanban-card bg-neutral-50 p-3 radius-8 mb-3"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            width: "280px",
            userSelect: "none",
            background: snapshot.isDragging ? "#f0f0f0" : "#ffffff",
            ...provided.draggableProps.style,
          }}
        >
          {/* Profile Picture */}
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="radius-8 mb-2 overflow-hidden d-flex justify-content-start align-items-center gap-2"
              style={{ maxHeight: "200px" }}
            >
              <Avatar
                src={contact_id?.profile_photo}
                alt="Profile"
                className=" object-fit-cover"
                sx={{ height: "80px", width: "80px", borderRadius: "8px" }}
              />
              <div className="d-flex flex-column justify-content-center align-items-start">
                <span className="kanban-title text-lg fw-semibold">
                  {contact_id?.name
                    ? contact_id?.name.charAt(0).toUpperCase() +
                    contact_id?.name.slice(1)
                    : "NA"}
                </span>
                <span
                  className="text-md text-light"
                  style={{ marginTop: "-4px" }}
                >
                  {contact_id?.phone_number}
                </span>
              </div>
            </div>
            {columnKey !== "pending" && (
              <div className="d-flex gap-2">
                {/* <button
                  onClick={() =>
                    window.open(`/users-list/${contact_id?._id}`, "_blank")
                  }
                  className="bg-info-focus text-info-600 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="majesticons:eye-line" className="text-xl" />
                </button> */}
                <button
                  onClick={() => showWhatsAppModal()}
                  type="button"
                  className="remove-item-btn bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="ic:baseline-whatsapp" />
                </button>
                <button
                  onClick={() => showPhoneModal()}
                  type="button"
                  className="remove-item-btn bg-warning-focus bg-hover-warning-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="akar-icons:phone" />
                </button>
              </div>
            )}
          </div>

          <label className="text-sm fw-bold text-secondary mt-3">Email</label>
          <div className="fw-medium ">{contact_id?.email}</div>
          <label className="text-sm fw-bold text-secondary mt-3">Address</label>
          <div className="fw-medium ">{contact_id?.address}</div>
          {columnKey === "completed" && (
            <>
              <label className="text-sm fw-bold text-secondary mt-3">
                Message
              </label>
              <div className="fw-medium ">{complete?.reason}</div>

              <label className="text-sm fw-bold text-secondary mt-3">
                Completed At
              </label>
              <div className="fw-medium ">
                {new Date(complete?.complete_date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </>
          )}
          <hr className="my-3" />
          {columnKey === "scheduled" && (
            <>
              <div className="mb-3">
                <label className="text-sm fw-bold text-secondary d-block mb-1">
                  Schedule
                </label>
                <div className="mb-1 ">
                  <strong>Reason:</strong> {task?.schedule?.reason}
                </div>
                <div className="">
                  <strong>Schedule At:</strong>{" "}
                  {new Date(task?.schedule?.schedule_date).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </div>
                {/* Reschedule Button */}
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-sm btn-warning mt-2"
                    onClick={() => onReschedule(task.id)}
                  >
                    Reschedule
                  </button>
                </div>
              </div>
              <hr className="my-3" />
            </>
          )}
          <label className="text-sm fw-bold text-secondary mt-3">
            Updated At
          </label>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2 pt-2">
              <Icon icon="solar:calendar-outline" className="icon text-lg" />
              <span className="text-secondary-light">
                {new Date(task?.updatedAt).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </span>
            </div>
          </div>
          <hr className="my-3" />

          {columnKey !== "completed" && columnKey !== "deleted" && (
            <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
              <button
                type="button"
                className="btn btn-primary text-light py-1"
                onClick={() => onSkip()}
              >
                Forward
              </button>
            </div>
          )}
        </div>
      )}
    </Draggable>
  );
};

export default PreleadCard;
